'use strict';

/*
 * EPROC-10643: lets the approver change the supplier contact persons of an order while it awaits
 * release ("Bestellung freizugeben"). Loads the selectable contacts, preselects the assigned ones
 * and saves the new selection through the order-v2 API. Rendered inside the supplier address card
 * (lib/orderHeadData.vsl) for the customer/MyAdmin view.
 */
module.exports = /* @ngInject */ function ($scope, feOrderSupplierContactService, notificationService, translationService) {

	let orderId;

	// ng-model targets need a dot (object property), otherwise ui-select writes the selection into a
	// child scope and save() would read the stale value (classic AngularJS scope shadowing, see
	// link-order.controller). EPROC-10643.
	$scope.data = {
		contacts: [],
		selected: []
	};
	// The editor is revealed only after the task-scoped API has confirmed that the current user
	// owns the claimed approval task for this order.
	$scope.authorized = false;
	$scope.saving = false;

	$scope.init = init;
	$scope.save = save;

	function init(id) {
		orderId = id;
		feOrderSupplierContactService.list.query({ orderId: orderId }).$promise.then(result => {
			$scope.data.contacts = result;
			// preselect the currently assigned contacts using the same references the dropdown holds
			$scope.data.selected = result.filter(contact => contact.selected);
			$scope.authorized = true;
		}, () => {
			$scope.authorized = false;
		});
	}

	function save() {
		if ($scope.saving) {
			return;
		}
		// an order must keep at least one supplier contact
		if (!$scope.data.selected || $scope.data.selected.length === 0) {
			notificationService.showErrorNotification(translationService.translate(_('Sie müssen mindestens einen Ansprechpartner selektieren.')));
			return;
		}
		$scope.saving = true;
		const contactIds = $scope.data.selected.map(contact => contact.id);

		feOrderSupplierContactService.save.update({ orderId: orderId }, { contactIds: contactIds }).$promise.then(() => {
			$scope.saving = false;
			notificationService.showSuccessNotification(translationService.translate(_('Ansprechpartner wurden gespeichert.')));
		}, () => {
			$scope.saving = false;
			$scope.authorized = false;
			notificationService.showErrorNotification(translationService.translate(_('Ansprechpartner konnten nicht gespeichert werden.')));
		});
	}

}
